import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { ConfigContext } from './ConfigContext';
import { getLightColorCode } from '@/utils/utilities';
import { useThemeDetails } from './ThemeDetailsContext';
var SuccessModal = function SuccessModal(_ref) {
    var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var open = _ref.open, onClose = _ref.onClose, title = _ref.title, message = _ref.message, gif = _ref.gif, buttonText = _ref.buttonText, _ref$width = _ref.width, width = _ref$width === void 0 ? '500px' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 'auto' : _ref$height;
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        "aria-labelledby": "success-modal-title",
        "data-testid": "success-modal",
        PaperProps: {
            sx: {
                width: width,
                height: height,
                textAlign: 'center'
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            p: 0,
            px: 2,
            py: 3
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: "radial-gradient(71.14% 71.14% at 50% 50%, ".concat(configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color, " 0%, ").concat(getLightColorCode(configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.button_color, 0.5), " 100%)"),
            borderRadius: '100%',
            width: '78px',
            height: '78px'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: (stateImages === null || stateImages === void 0 ? void 0 : stateImages.Success) || gif,
        alt: "Success",
        width: 81,
        height: 81
    }))), /*#__PURE__*/ React.createElement(Typography, {
        id: "success-modal-title",
        variant: "h6",
        component: "h2",
        sx: {
            mb: 2
        }
    }, title), message), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            p: 0,
            px: 3,
            py: 2,
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        variant: "contained",
        color: "success",
        "data-testid": "success-modal-close-button",
        sx: {
            background: configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.button_color,
            color: configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.button_text_color,
            textTransform: 'none',
            fontSize: '16px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#FFFFFF",
        fontWeight: 600
    }, buttonText))));
};
export default SuccessModal;
